module.exports = ".disabled {\n  visibility: hidden;\n  transition: transform .25s ease; }\n\n.wraper {\n  margin-left: 250px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/license-portal.component.scss
// module id = 955
// module chunks = 1